import type {SearchCriteriaRaw} from '../../../types';
import {createUserRule} from '../userRule';
import type {UserRule, TSearchTypeUser} from '../types';

export type RawUserSearchCriteria = SearchCriteriaRaw<TSearchTypeUser>;

export const rawUserCriteriaToRuleObject = (
	criteria: RawUserSearchCriteria,
): UserRule => {
	return createUserRule({
		type: criteria.subtype1,
		userId: parseInt(criteria.value1) || 0,
	});
};

export default rawUserCriteriaToRuleObject;
